import { render, staticRenderFns } from "./cModalViewDetalleDispatch.vue?vue&type=template&id=88c080fa&scoped=true"
import script from "./cModalViewDetalleDispatch.vue?vue&type=script&lang=js"
export * from "./cModalViewDetalleDispatch.vue?vue&type=script&lang=js"
import style0 from "./cModalViewDetalleDispatch.vue?vue&type=style&index=0&id=88c080fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c080fa",
  null
  
)

export default component.exports